import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M19 11.707c-.6 0-1 .39-1 .977v3.91c0 .587-.4.979-1 .979H3c-.6 0-1-.392-1-.979v-3.91c0-.586-.4-.977-1-.977s-1 .39-1 .977v3.91c0 1.662 1.3 2.933 3 2.933h14c1.7 0 3-1.27 3-2.933v-3.91c0-.586-.4-.977-1-.977M5.7 6.527 9 3.299v9.385c0 .586.4.978 1 .978s1-.393 1-.979V3.3l3.3 3.226c.2.196.4.293.7.293s.5-.098.7-.293a.93.93 0 0 0 0-1.368l-5-4.889c-.1-.097-.2-.195-.3-.195-.2-.098-.5-.098-.8 0-.1.098-.2.098-.3.196l-5 4.888a.93.93 0 0 0 0 1.367c.4.391 1 .393 1.4.002"
    }, null, -1)
  ]))]))
}
export default { render: render }